import { CIcon } from '~/icons/types'

export const ciWheelLoaders: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M3.376 14.468h3.2a.784.784 0 0 0 .783-.783v-2.362a.785.785 0 0 0-.783-.784h-3.2a.784.784 0 0 0-.783.784v2.362a.784.784 0 0 0 .783.783Zm.206-2.939h2.79v1.955h-2.79V11.53Zm11.81 2.939h2.729a.784.784 0 0 0 .783-.783v-2.362a.785.785 0 0 0-.783-.784h-2.73a.785.785 0 0 0-.782.784v2.362a.783.783 0 0 0 .783.783Zm.208-2.939h2.32v1.955H15.6V11.53Z'
    },
    {
      d:
        'M23.512 17.17h-.52v-.32a.493.493 0 0 0-.985 0v.32h-.82V8.712a1.578 1.578 0 0 0-1.139-1.513l-8.439-2.955-.033-.01a1.98 1.98 0 0 0-1.069 0h-.01L1.149 7.193A1.587 1.587 0 0 0 0 8.712v7.9a1.549 1.549 0 0 0 1.547 1.547h5.106a2.12 2.12 0 0 0 4.126 0h.44a2.121 2.121 0 0 0 4.126 0H22v1.19a.492.492 0 1 0 .984 0v-1.195h.521a.493.493 0 0 0 .007-.984ZM1.421 8.145l.009-.005 9.344-2.96a1 1 0 0 1 .52 0l8.435 2.955.033.01a.64.64 0 0 1 .168.075H1.252a.536.536 0 0 1 .169-.075Zm7.295 10.654a1.135 1.135 0 0 1-1.022-.643h2.044a1.135 1.135 0 0 1-1.022.643Zm3.5-1.627H9.869v-5.535a.1.1 0 0 1 .1-.1h2.141a.1.1 0 0 1 .1.1l.006 5.535Zm1.066 1.627a1.135 1.135 0 0 1-1.022-.643h2.04a1.133 1.133 0 0 1-1.018.643Zm6.918-1.63h-7v-5.532a1.093 1.093 0 0 0-1.092-1.092h-2.14a1.094 1.094 0 0 0-1.093 1.092v5.533H1.547a.564.564 0 0 1-.562-.563v-7.4H20.2v7.963Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'wheel-loaders',
  type: 'thin'
}
